/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_LabelInputs */

const en_dialog_label = /** @type {(inputs: Dialog_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Label`)
};

const es_dialog_label = /** @type {(inputs: Dialog_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etiqueta`)
};

/**
* | output |
* | --- |
* | "Label" |
*
* @param {Dialog_LabelInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_label = /** @type {((inputs?: Dialog_LabelInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_LabelInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_label(inputs)
	return en_dialog_label(inputs)
});